export const cartModal = {
  en: {
    emptyTitle: 'The basket is empty.',
    emptyTitleLink: 'Click here',
    emptyTitle2: 'to continue shopping',
    note: 'Write your wishes before ordering',
    total: 'Total',
    buttonContinue: 'Continue shopping',
    buttonCheckout: 'Calculate',
  },
  ua: {
    emptyTitle: 'Корзина порожня.',
    emptyTitleLink: 'Натисність сюди',
    emptyTitle2: 'щоб продовжити покупки',
    note: 'Напишіть ваші побажання до заказу',
    total: 'Загальна сума',
    buttonContinue: 'Продовжити покупки',
    buttonCheckout: 'Розрахувати',
  },
};
